import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";
import logo from "../../assets/inryde_logo.png";

export default function Footer() {
  const socialLinks = [
    { icon: <FaInstagram />, name: "Instagram", color: "#e4405f", url: "https://www.instagram.com/inryde_official/" },
    { icon: <FaFacebookF />, name: "Facebook", color: "#1877f2", url: "https://www.facebook.com/profile.php?id=61583528784859" },
    { icon: <FaXTwitter />, name: "X", color: "#000000", url: "https://x.com/inryde_official" },
    { icon: <FaLinkedinIn />, name: "LinkedIn", color: "#0a66c2", url: "https://www.linkedin.com/company/inryde/" },
  ];

  const footerLinks = [
    {
      title: "Services",
      links: [
        { name: "Bike Rides", path: "/services" },
        { name: "Car Rides", path: "/services" },
        { name: "Auto Rides", path: "/services" },
        { name: "Parcels", path: "/services" },
      ],
    },
    {
      title: "Support",
      links: [
        { name: "About", path: "/about" },
        { name: "Services", path: "/services" },
        { name: "Contact Us", path: "/contact" },
      ],
    },
    {
      title: "Policies",
      links: [
        { name: "User Privacy Policy", path: "/user-privacy-policy" },
        { name: "Rider Privacy Policy", path: "/rider-privacy-policy" },
        { name: "User Terms and Conditions", path: "/user-terms-and-conditions" },
        { name: "Rider Terms and Conditions", path: "/rider-terms-and-conditions" },
        { name: "Cancellation Policy", path: "/cancellation-policy" },
        { name: "Refund Policy", path: "/refund-policy" },
        { name: "Shipping and Delivery Policy", path: "/shippinganddriving-policy" },
      ],
    },
  ];

  return (
    <footer style={{ background: "#1C1C1C", color: "white", position: "relative", overflow: "hidden" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "64px 20px 32px", position: "relative", zIndex: 10 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "28px",
            marginBottom: "48px",
            textAlign: "left",
            alignItems: "start",
          }}
        >
          {/* Brand Section */}
          <div style={{ textAlign: "left" }}>
            <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "20px" }}>
              <img src={logo} alt="InRyde Logo" style={{ height: "270px", width: "auto", marginLeft: "-50px", marginTop: "-86px", marginBottom: "-110px", objectFit: "contain" }} />
            </div>
            <p style={{ color: "#9ca3af", lineHeight: "1.8", marginBottom: "24px", fontSize: "15px" }}>
              India’s fastest growing ride-sharing platform. Book bikes, cars, and autos with just a tap.
            </p>

            {/* Contact Info */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", textAlign: "left" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", color: "#9ca3af" }}>
                <span style={{ color: "#E63946", fontSize: "20px" }}>✉️</span>
                <span> infoinryde@gmail.com </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", color: "#9ca3af" }}>
                <span style={{ color: "#FFC300", fontSize: "20px" }}>📞</span>
                <span>+91 98663 98548</span>
              </div>
              <div style={{ display: "flex",  gap: "12px", color: "#9ca3af" }}>
                <span style={{ color: "#22c55e", fontSize: "20px" }}>📍</span>
                <span> 2nd floor, D.no 50-1-40 Near ASR Statue, Seethammadhara, Visakhapatnam - 530013</span>
              </div>
            </div>
          </div>

          {/* Footer Links */}
          {footerLinks.map((section) => (
            <div key={section.title} style={{ textAlign: "left", marginLeft: "20px" }}>
              <h4 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "20px" }}>{section.title}</h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                      style={{ color: "#9ca3af", textDecoration: "none", transition: "all 0.3s ease", fontSize: "15px" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = "white"; e.currentTarget.style.paddingLeft = "6px"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "#9ca3af"; e.currentTarget.style.paddingLeft = "0"; }}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div style={{ height: "1px", background: "linear-gradient(to right, transparent, #4b5563, transparent)", marginBottom: "32px" }} />

        {/* Bottom Section */}
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "16px", textAlign: "center" }}>
          
          {/* Copyright */}
          <p style={{ color: "#9ca3af", fontSize: "14px", margin: 0 }}>
            © 2025 InRyde. All rights reserved by{" "}
            <strong className="bgt-shine">BGT GROUPS</strong>
          </p>

          {/* Social Icons */}
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "14px" }}>
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: "40px", height: "40px", background: "#374151", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "18px", transition: "all 0.3s ease" }}
                onMouseEnter={(e) => { e.currentTarget.style.background = social.color; e.currentTarget.style.transform = "scale(1.2)"; e.currentTarget.style.boxShadow = `0 0 10px ${social.color}`; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "#374151"; e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "none"; }}
              >
                {social.icon}
              </a>
            ))}
          </div>

          {/* Designed & Developed */}
          <p style={{ color: "#9ca3af", fontSize: "14px", margin: 0, display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
            Designed and Developed by
            <strong
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                background: "linear-gradient(90deg, #A8E6FF, #9FFFC2)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}
            >
              DESIGN BLOCKS
            </strong>
          </p>
        </div>
      </div>

      {/* Gold Animation CSS */}
      <style>{`
        .bgt-shine {
          background: linear-gradient(90deg, #a67c00, #d4af37, #ffecb3, #b8860b);
          background-size: 300%;
          background-position: left;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 900;
          cursor: pointer;
          transition: background-position 0.6s ease;
        }
        .bgt-shine:hover {
          background-position: right;
        }

        @media (max-width: 768px) {
          footer div[style*="space-between"] {
            flex-direction: column;
            text-align: center;
            gap: 16px;
          }
          footer img {
            margin: 0;
          }
          footer div[style*="marginLeft: 10px"] {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </footer>
  );
}
